import { HttpErrorResponse } from '@angular/common/http';
import { ApiError } from './api-error';
import { ApiErrorCode } from './api-error-code';

export function toApiError(error: unknown): ApiError | null {
  return fromValue(error) ?? fromCause(error);
}

export function hasCode<C extends ApiErrorCode>(
  error: ApiError,
  code: C,
): error is ApiError<C>;
export function hasCode(error: unknown, code: ApiErrorCode): boolean;
export function hasCode(error: unknown, code: ApiErrorCode): boolean {
  return toApiError(error)?.code === code;
}

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

function fromValue(value: unknown): ApiError | null {
  if (value instanceof ApiError) {
    return value;
  }
  if (value instanceof HttpErrorResponse) {
    return fromEnvelope(value.error, value.status, value);
  }
  return fromEnvelope(value, undefined, value);
}

function fromCause(error: unknown): ApiError | null {
  return error instanceof Error ? fromValue(error.cause) : null;
}

function fromEnvelope(
  body: unknown,
  status: number | undefined,
  cause: unknown,
): ApiError | null {
  if (!isRecord(body) || !isRecord(body['error'])) {
    return null;
  }
  const envelope = body['error'];
  const code = envelope['code'];

  if (typeof code !== 'number') {
    return null;
  }
  const message = envelope['message'];
  return new ApiError(
    code,
    typeof message === 'string' ? message : '',
    envelope['data'] ?? null,
    status,
    cause,
  );
}
